import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getDefaultRouteForRoles } from '../utils/postLoginRedirect';
import { hasValidAccessToken } from '../utils/accessTokenState';
import { getLoginPathForPortal, resolvePortalForGuard } from '../utils/loginPortal';

interface RequireRoleProps {
  children: React.ReactNode;
  requiredRole: string | string[];
  redirectTo?: string;
}

const getDefaultDashboard = (roles?: string[], onboardingComplete?: boolean): string => {
  return getDefaultRouteForRoles(roles, onboardingComplete);
};

export const RequireRole: React.FC<RequireRoleProps> = ({
  children,
  requiredRole,
  redirectTo,
}) => {
  const { hasAnyRole, user } = useAuth();
  const location = useLocation();
  const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

  if (!hasValidAccessToken() || !user) {
    const loginPath = getLoginPathForPortal(resolvePortalForGuard(location.pathname));
    return <Navigate to={loginPath} replace />;
  }

  if (!hasAnyRole(roles)) {
    const destination = redirectTo || getDefaultDashboard(user.roles, user.onboarding_complete);
    return <Navigate to={destination} replace />;
  }

  return <>{children}</>;
};

